import { render, staticRenderFns } from "./EdmStatView.vue?vue&type=template&id=719016aa&scoped=true&"
import script from "./EdmStatView.vue?vue&type=script&lang=js&"
export * from "./EdmStatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719016aa",
  null
  
)

export default component.exports